import { grupoCboHistorico } from '@atendimento/detail/acessos'
import { ACOMPANHAMENTOS_URL } from '@atendimento/detail/acompanhamentos/AcompanhamentosView'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { ReactElement } from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { grupoCboVisualizarAcompanhamentos } from 'view/cidadao/authorization/acessos'

import { deveMostrarAbaVacinacoes } from './util-atendimentoIndividual'

export interface AtendimentoIndividualRootViewProps {
  hasToRenderAcompanhamentos: boolean | undefined
  isRetificacao: boolean
  isObservacaoEmAndamento: boolean
  tipoAtendimentoProfissional: TipoAtendimentoProfissional

  renderSoapView: () => ReactElement
  renderFolhaRostoView: () => ReactElement
  renderAtendimentoHistoricoView: () => ReactElement
  renderCidadaoDetail: () => ReactElement
  renderVacinacao: () => ReactElement
  renderAcompanhamentos: () => ReactElement
  renderAgendamentos: () => ReactElement
  renderSistemasExternos: () => ReactElement
  renderProntuarioFamiliar: () => ReactElement
}

export function AtendimentoIndividualRootView(props: Readonly<AtendimentoIndividualRootViewProps>) {
  const {
    hasToRenderAcompanhamentos,
    isRetificacao,
    isObservacaoEmAndamento,
    tipoAtendimentoProfissional,
    renderSoapView,
    renderFolhaRostoView,
    renderAtendimentoHistoricoView,
    renderCidadaoDetail,
    renderVacinacao,
    renderAcompanhamentos,
    renderAgendamentos,
    renderSistemasExternos,
    renderProntuarioFamiliar,
  } = props

  const { PILOTO_PRONTUARIO_FAMILIAR_ENABLED, RETIFICACAO_TRANSCRICAO_CADERNETA_ENABLED } = useFlags()
  const match = useRouteMatch()

  const canEdit = isObservacaoEmAndamento || isRetificacao
  const redirectTo = `${match.url}/${canEdit ? 'soap' : 'folha-rosto'}`
  const showVacinacao = deveMostrarAbaVacinacoes(
    isRetificacao,
    tipoAtendimentoProfissional,
    RETIFICACAO_TRANSCRICAO_CADERNETA_ENABLED
  )

  return (
    <PecSwitch>
      <Redirect exact path={match.url} to={redirectTo} />
      <Route path={`${match.url}/soap`} render={renderSoapView} />
      {showVacinacao && <Route path={`${match.url}/vacinacao`} render={renderVacinacao} />}

      {!isRetificacao && (
        <>
          <Route path={`${match.url}/folha-rosto`} render={renderFolhaRostoView} />
          <PrivateRoute
            path={`${match.url}/historico`}
            render={renderAtendimentoHistoricoView}
            permission={grupoCboHistorico.visualizar}
          />
          <Route path={`${match.url}/cadastro-cidadao`} render={renderCidadaoDetail} />
          {hasToRenderAcompanhamentos && (
            <PrivateRoute
              path={`${match.url}/${ACOMPANHAMENTOS_URL}`}
              render={renderAcompanhamentos}
              permission={Permissions.visualizarProntuario}
              cbos={grupoCboVisualizarAcompanhamentos}
            />
          )}
          <Route path={`${match.path}/agendamentos/:cidadaoId`} render={renderAgendamentos} />
          <Route path={`${match.path}/sistemas-externos/:iframeId?`} render={renderSistemasExternos} />
          {PILOTO_PRONTUARIO_FAMILIAR_ENABLED && (
            <PrivateRoute
              path={`${match.path}/prontuario-familiar`}
              render={renderProntuarioFamiliar}
              permission={Permissions.gestaoDeCadastros.visualizarCadastroIndividual}
            />
          )}
        </>
      )}
    </PecSwitch>
  )
}
